export const DELAY_PERIOD_MARK_PREFIX = 'event-delay-controller.';
export const DELAY_PERIOD_MARK_START = `${DELAY_PERIOD_MARK_PREFIX}start`;
export const DELAY_PERIOD_MARK_END = `${DELAY_PERIOD_MARK_PREFIX}end`;
